// extracted by mini-css-extract-plugin
export default {"warning-message":"GDZBK"};